// Source: https://github.com/GA-MO/react-confirm-alert
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../sass/content/react-confirm-alert-override.css';

export default function createConfirmAlert(confirmAlertObject) {
  confirmAlert(confirmAlertObject)
};

// ---------------
// How to use it:
// ---------------

// -- The key/value options for the confirmAlertObject
// confirmAlert({
//  title: 'Confirm to submit',                        // Title dialog
//  message: 'Are you sure you want to do this?',      // Message dialog
//  childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
//   buttons: [
//    {
//      label: 'Cancel'                              // Text for button
//      onClick: props.onCancel()                    // Action for button
//    }
//  ]
//})

// -- Example case for a function component
// const SomeComponent = (props) => {
//   let confirmAlertObject = {
//     title: 'Confirm Action',
//     message: 'Are you sure you want to do this?',
//     buttons: [
//      {
//        label: 'Cancel',
//        onClick: props.onCancel()
//      },
//      {
//        label: 'Confirm',
//        onClick: props.onClick()
//      }
//    ]
//   };
//   render() {
//     return (
//       <div className="container">
//         <button onClick={() => createConfirmAlert(confirmAlertObject)}>Create Confirm Dialog</button>
//       </div>
//     );
//   }
// }

// -- Example case for a class component
// class App extends React.Component {
//   state = {
//     showDialog: false,
//   }
//   render() {
//     return (
//       <div>
//         {
//           this.state.showDialog &&
//           <ReactConfirmAlert
//             title="Confirm to submit"
//             message="Are you sure about this?"
//             confirmLabel="Confirm"
//             cancelLabel="Cancel"
//             onConfirm={() => alert('Action after Confirm')}
//             onCancel={() => alert('Action after Cancel')}
//           />
//         }
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/shared/functions/createConfirmAlert.js